import { useEffect } from "react";
import "./FastFacts.css"

const FastFacts = ({ countryData }) => {
 const fastFacts = countryData?.fastFacts || {};
  // useEffect(()=> {
  //   // This effect can be used for any side effects related to fastFacts
  //   console.log("Fast Facts data loaded:", countryData);
  // }, [countryData]);

  return (
    <div className="fast-facts-container">
      <div className="facts-grid">
        <div className="fact-card">
          <div className="fact-icon gdp-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2V22M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
                stroke="#0095FF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="fact-content">
            <h3>GDP</h3>
            <p>{fastFacts?.gdp}</p>
          </div>
        </div>

        <div className="fact-card">
          <div className="fact-icon dialing-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7294C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1468 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77383 17.3147 6.72534 15.2662 5.19 12.85C3.49998 10.2412 2.44824 7.27097 2.12 4.18C2.09501 3.90347 2.12788 3.62476 2.2165 3.36162C2.30513 3.09849 2.44757 2.85669 2.63477 2.65162C2.82196 2.44655 3.04981 2.28271 3.30379 2.17052C3.55778 2.05833 3.83234 2.00026 4.11 2H7.11C7.59531 1.99522 8.06579 2.16708 8.43376 2.48353C8.80173 2.79999 9.04208 3.23945 9.11 3.72C9.23662 4.68007 9.47145 5.62273 9.81 6.53C9.94455 6.88792 9.97366 7.27691 9.89391 7.65088C9.81415 8.02485 9.62886 8.36811 9.36 8.64L8.09 9.91C9.51356 12.4135 11.5865 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9752 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0554 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z"
                stroke="#0095FF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="fact-content">
            <h3>Dialing Code</h3>
            <p>{fastFacts?.dialingCode}</p>
          </div>
        </div>

        <div className="fact-card">
          <div className="fact-icon currency-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
                stroke="#0095FF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="fact-content">
            <h3>Currency</h3>
            <p>{fastFacts?.currency}</p>
          </div>
        </div>

        <div className="fact-card">
          <div className="fact-icon university-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 1L1 7L12 13L23 7L12 1Z"
                stroke="#0095FF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M1 7V16" stroke="#0095FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M23 7V16" stroke="#0095FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M4 10V16" stroke="#0095FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M20 10V16" stroke="#0095FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M1 16H23" stroke="#0095FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 13V23" stroke="#0095FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8 20H16" stroke="#0095FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="fact-content">
            <h3>Universities</h3>
            <p>{fastFacts?.universities}</p>
          </div>
        </div>
      </div>

      <div className="why-study-section">
        <h2>Why Study in {countryData.name}?</h2>
        <p>{fastFacts?.whyStudy}</p>
        <button className="read-more-btn">Read More</button>
      </div>

      <div className="trending-section">
        <div className="trending-header">
          <h2>What's Trending in {countryData.name}?</h2>
          <div className="trending-nav">
            <button className="nav-btn prev">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15 18L9 12L15 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button className="nav-btn next">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 18L15 12L9 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="trending-articles">
          {fastFacts?.trending &&
            fastFacts?.trending.map((article, index) => (
              <div className="article-card" key={index}>
                <img src={article.image || "/placeholder.svg"} alt={article.title} className="article-img" />
                <h3>{article.title}</h3>
                <div className="article-meta">{article.readTime}</div>
                <p>{article.excerpt}</p>
                <a href={article.link} className="read-now-btn">
                  Read Now
                </a>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default FastFacts
